import { forwardRef } from 'react';
import { StyledModalName } from './styled';
import { useModalContext } from '../../../contexts/modal';

const ModalName = forwardRef((props, ref) => {
  const { nameProps } = useModalContext();

  return <StyledModalName {...nameProps(ref, props)} />;
});

export default ModalName;
